import Layout from "@c/Layout";
import Page404 from "@v/errors/Page404";
import Test from "@v/Test";
import { randomChars } from "@/libs/utils";

export const pageNotFoundRoute = {
    path: "/",
    component: Layout,
    children: [
        {
            path: "*",
            meta: {
                title: "页面没有找到",
            },
            component: Page404,
        },
    ],
};

export const fixedRoutes = [pageNotFoundRoute];

if (process.env.NODE_ENV === "development") {
    fixedRoutes.unshift({
        path: "/test/test",
        component: Layout,
        children: [
            {
                path: "/",
                component: Test,
            },
        ],
    });
}

export default [
    {
        path: "/login",
        name: "login",
        meta: {
            title: "登录",
        },
        component: () => import("@v/Login"),
    },
    {
        path: "/monitor",
        name: "monitor",
        meta: {
            title: "监控大屏",
        },
        component: () => import("@v/monitor/Index"),
    },
    {
        path: randomChars(),
        component: Layout,
        children: [
            {
                path: "/user/edit",
                name: "editMyProfile",
                meta: {
                    title: "编辑资料",
                },
                component: () => import("@v/admin-users/EditProfile"),
            },
            {
                path: "/area",
                name: "area",
                meta: {
                    title: "区域列表",
                },
                component: () => import("@v/areas/Index"),
            },
            {
                path: "/area/create",
                name: "areaCreate",
                meta: {
                    title: "添加区域",
                },
                component: () => import("@v/areas/Form"),
            },
            {
                path: "/area/:id/edit",
                name: "areaEdit",
                meta: {
                    title: "编辑区域",
                },
                component: () => import("@v/areas/Formedit"),
            },
            {
                path: "/parking/:area_id?",
                name: "bikeAreaGaode",
                meta: {
                    title: "停车区管理",
                },
                component: () => import("@v/areas/parking/Index"),
            },
            {
                path: "/bike",
                name: "bike",
                meta: {
                    title: "车辆列表",
                },
                component: () => import("@v/bikes/Index"),
            },
            {
                path: "/bikes/contro",
                name: "bikesContro",
                meta: {
                    title: "车辆控制",
                },
                component: () => import("@v/bikes/BikeContro"),
            },
            {
                path: "/bike/create",
                name: "bikeCreate",
                meta: {
                    title: "添加车辆",
                },
                component: () => import("@v/bikes/Form"),
            },
            {
                path: "/bike/:id/edit",
                name: "bikeEdit",
                meta: {
                    title: "编辑车辆",
                },
                component: () => import("@v/bikes/Form"),
            },
            {
                path: "/bike/distribution_map",
                name: "DistributionMap",
                meta: {
                    title: "车辆分布图",
                },
                component: () => import("@v/bikes/DistributionMap"),
            },
            {
                path: "/area/area_setting",
                name: "AreaSettings",
                meta: {
                    title: "区域基础配置",
                },
                component: () => import("@v/areas/Setting"),
            },
            {
                path: "/deposit",
                name: "deposit",
                meta: {
                    title: "押金管理",
                },
                component: () => import("@v/deposits/Index"),
            },
            {
                path: "/profit",
                name: "profit",
                meta: {
                    title: "收益管理",
                },
                component: () => import("@v/profit/Index"),
            },
            {
                path: "/userList",
                name: "userList",
                meta: {
                    title: "用户列表",
                },
                component: () => import("@v/user/Index"),
            },
            {
                path: "/userWallet",
                name: "userWallet",
                meta: {
                    title: "钱包管理",
                },
                component: () => import("@v/user/Wallet"),
            },
            {
                path: "/orders",
                name: "orders",
                meta: {
                    title: "订单管理",
                },
                component: () => import("@v/orders/Index"),
            },
            {
                path: "/ordersTrajectory",
                name: "ordersTrajectory",
                meta: {
                    title: "订单轨迹",
                },
                component: () => import("@v/orders/ordersTrajectory"),
            },
            {
                path: "/orderRent",
                name: "orderRent",
                meta: {
                    title: "日租订单管理",
                },
                component: () => import("@v/order-rent/Index"),
            },
            {
                path: "/orderRentTrajectory",
                name: "orderRentTrajectory",
                meta: {
                    title: "日租订单轨迹",
                },
                component: () => import("@v/order-rent/ordersTrajectory"),
            },
            {
                path: "/bike_troubles",
                name: "bikeTroubles",
                meta: {
                    title: "工单管理",
                },
                component: () => import("@v/work-order/Index"),
            },
            {
                path: "/worker",
                name: "worker",
                meta: {
                    title: "地勤人员",
                },
                component: () => import("@v/worker/Index"),
            },
            {
                path: "/worker/achievements",
                name: "workerAchievements",
                meta: {
                    title: "地勤绩效",
                },
                component: () => import("@v/worker/Achievements"),
            },
            {
                path: "/dashboard",
                name: "dashboard",
                meta: {
                    title: "概况",
                },
                component: () => import("@v/dashboard/Index"),
            },
            {
                path: "/feedback",
                name: "feedback",
                meta: {
                    title: "问题反馈",
                },
                component: () => import("@v/feedback/Index"),
            },
            {
                path: "/user_repaired",
                name: "user_repaired",
                meta: {
                    title: "用户报修",
                },
                component: () => import("@v/user-repaired/Index"),
            },
            {
                path: "/advertisements",
                name: "advertisements",
                meta: {
                    title: "广告管理",
                },
                component: () => import("@v/advertisement/Index"),
            },
            {
                path: "/advertisements/create",
                name: "addadvertisements",
                meta: {
                    title: "添加广告",
                },
                component: () => import("@v/advertisement/Form"),
            },
            {
                path: "/advertisements/:id/edit",
                name: "advertisementsEdit",
                meta: {
                    title: "编辑广告",
                },
                component: () => import("@v/advertisement/Form"),
            },
            {
                path: "/advertisement-children/:pid",
                name: "advertisement-children",
                meta: {
                    title: "子广告管理",
                },
                component: () => import("@v/advertisement-children/Index"),
            },
            {
                path: "/advertisement-children/create/:pid",
                name: "advertisement-children-create",
                meta: {
                    title: "添加子广告",
                },
                component: () => import("@v/advertisement-children/Form"),
            },
            {
                path: "/advertisement-children/:id/edit",
                name: "advertisementsChildrenEdit",
                meta: {
                    title: "编辑子广告",
                },
                component: () => import("@v/advertisement-children/Form"),
            },
            {
                path: "/announcements",
                name: "announcements",
                meta: {
                    title: "公告管理",
                },
                component: () => import("@v/announcements/Index"),
            },
            {
                path: "/announcements/create",
                name: "announcementsCreate",
                meta: {
                    title: "添加公告",
                },
                component: () => import("@v/announcements/Form"),
            },
            {
                path: "/announcements/:id/edit",
                name: "announcementsEdit",
                meta: {
                    title: "编辑公告",
                },
                component: () => import("@v/announcements/Form"),
            },
            {
                path: "/box_binding",
                name: "box_binding",
                meta: {
                    title: "中控绑定管理",
                },
                component: () => import("@v/box-binding/Index"),
            },
            {
                path: "/box_binding/warningLogs",
                name: "boxWarningLogs",
                meta: {
                    title: "中控日志",
                },
                component: () => import("@v/box-binding/WarningLogs"),
            },
            {
                path: "/card_riding",
                name: "riding_card",
                meta: {
                    title: "骑行卡列表",
                },
                component: () => import("@v/activity/card-riding/Index"),
            },
            {
                path: "/card_riding/create",
                name: "riding_card_create",
                meta: {
                    title: "添加骑行卡",
                },
                component: () => import("@v/activity/card-riding/Form"),
            },
            {
                path: "/card_riding/:id/edit",
                name: "riding_cardEdit",
                meta: {
                    title: "编辑骑行卡",
                },
                component: () => import("@v/activity/card-riding/Form"),
            },
            {
                path: "/riding_card_order",
                name: "riding_card_order",
                meta: {
                    title: "骑行卡订单",
                },
                component: () => import("@v/activity/card-riding-order/Index"),
            },
            {
                path: "/riding_card_user_bags",
                name: "riding_card_user_bags",
                meta: {
                    title: "用户骑行卡",
                },
                component: () =>
                    import("@v/activity/card-riding-user-bags/Index"),
            },
            {
                path: "/recharge_configuration",
                name: "recharge_configuration",
                meta: {
                    title: "充值配置列表",
                },
                component: () =>
                    import("@v/activity/recharge-configuration/Index"),
            },
            {
                path: "/recharge_configuration/:id/edit",
                name: "recharge_configuration_edit",
                meta: {
                    title: "编辑充值配置",
                },
                component: () =>
                    import("@v/activity/recharge-configuration/Form"),
            },
            {
                path: "/recharge_configuration/create",
                name: "recharge_configuration_create",
                meta: {
                    title: "添加充值配置",
                },
                component: () =>
                    import("@v/activity/recharge-configuration/Form"),
            },
            {
                path: "/recharge_order",
                name: "recharge_order",
                meta: {
                    title: "充值订单列表",
                },
                component: () => import("@v/recharge-order/Index"),
            },
            {
                path: "/recharge_statistics",
                name: "recharge_statistics",
                meta: {
                    title: "充值统计",
                },
                component: () => import("@v/recharge-order/Statistics"),
            },
            {
                path: "/activity_send_sms",
                name: "activity_send_sms",
                meta: {
                    title: "群发短信",
                },
                component: () => import("@v/activity/activity-sms/Form"),
            },
            {
                path: "/group_send_sms_list",
                name: "group_send_sms_list",
                meta: {
                    title: "群发短信",
                },
                component: () => import("@v/activity/activity-sms/Index"),
            },
            {
                path: "/coupon/create",
                name: "coupon_create",
                meta: {
                    title: "添加优惠券",
                },
                component: () => import("@v/activity/coupon/From"),
            },
            {
                path: "/coupon/:id/edit",
                name: "coupon_edit",
                meta: {
                    title: "编辑优惠券",
                },
                component: () => import("@v/activity/coupon/From"),
            },
            {
                path: "/coupon",
                name: "coupon",
                meta: {
                    title: "优惠券配置列表",
                },
                component: () => import("@v/activity/coupon/Index"),
            },
            {
                path: "/coupon_user_bags",
                name: "coupon_user_bags",
                meta: {
                    title: "用户优惠券列表",
                },
                component: () => import("@v/activity/coupon_user_bags/Index"),
            },
            {
                path: "/invite_new_users_configs",
                name: "invite_new_users_configs",
                meta: {
                    title: "邀请新用户配置列表",
                },
                component: () =>
                    import("@v/activity/invite-new-users-configs/Index"),
            },
            {
                path: "/invite_new_users",
                name: "invite_new_users",
                meta: {
                    title: "新用户列表",
                },
                component: () => import("@v/activity/invite-new-users/Index"),
            },
            {
                path: "/invite_new_users_configs/create",
                name: "invite_new_users_configs_create",
                meta: {
                    title: "添加邀请新用户配置",
                },
                component: () =>
                    import("@v/activity/invite-new-users-configs/Form"),
            },
            {
                path: "/invite_new_users_configs/:id/edit",
                name: "invite_new_users_configs_edit",
                meta: {
                    title: "修改邀请新用户配置",
                },
                component: () =>
                    import("@v/activity/invite-new-users-configs/Form"),
            },
            {
                path: "/invite_new_users_give_gift_log",
                name: "invite_new_users_give_gift_log",
                meta: {
                    title: "获得奖励列表",
                },
                component: () =>
                    import("@v/activity/invite-new-users-give-gift-log/Index"),
            },

            {
                path: "/deposit_cards",
                name: "deposit_card",
                meta: {
                    title: "免押金卡列表",
                },
                component: () => import("@v/activity/deposit-cards/Index"),
            },
            {
                path: "/deposit_cards/create",
                name: "deposit_card_create",
                meta: {
                    title: "添加免押金卡",
                },
                component: () => import("@v/activity/deposit-cards/Form"),
            },
            {
                path: "/deposit_cards/:id/edit",
                name: "deposit_cardEdit",
                meta: {
                    title: "编辑免押金卡",
                },
                component: () => import("@v/activity/deposit-cards/Form"),
            },
            {
                path: "/deposit_card_order",
                name: "deposit_card_order",
                meta: {
                    title: "免押金卡订单",
                },
                component: () => import("@v/activity/deposit-cards/Orders"),
            },
            {
                path: "/apply_add_parking",
                name: "apply_add_parking",
                meta: {
                    title: "申请增加还车点",
                },
                component: () => import("@v/apply-add-parking/Index"),
            },
            {
                path: "/punishment_orders",
                name: "punishment_orders",
                meta: {
                    title: "罚单列表",
                },
                component: () => import("@v/punishment-orders/Index"),
            },
            {
                path: "/student",
                name: "student",
                meta: {
                    title: "学生认证列表",
                },
                component: () => import("@v/user/Student"),
            },
            {
                path: "/punishment_orders/:id/edit",
                name: "punishment_ordersE",
                meta: {
                    title: "编辑免押金卡",
                },
                component: () => import("@v/punishment-orders/Form"),
            },
            {
                path: "/punishment_orders/create",
                name: "punishment_orders_create",
                meta: {
                    title: "添加罚单",
                },
                component: () => import("@v/punishment-orders/Form"),
            },
            {
                path: "/refund_balance_order",
                name: "refund_balance_order",
                meta: {
                    title: "退款订单列表",
                },
                component: () => import("@v/refund-balance-order/Index"),
            },
            {
                path: "/admin_merchants",
                name: "admin-merchantEdit",
                meta: {
                    title: "配置管理",
                },
                component: () => import("@v/admin-merchant/Index"),
            },
            {
                path: "/admin_merchants/create",
                name: "admin-merchantEdit",
                meta: {
                    title: "添加新配置",
                },
                component: () => import("@v/admin-merchant/Form"),
            },
            {
                path: "/admin_merchants/:id/edit",
                name: "admin-merchantEdit",
                meta: {
                    title: "编辑配置信息",
                },
                component: () => import("@v/admin-merchant/Form"),
            },
            {
                path: "/admin_merchant_config/get",
                name: "admin_merchant_config/get",
                meta: {
                    title: "配置信息",
                },
                component: () => import("@v/admin-merchant/Config"),
            },
            {
                path: "admin_merchant_config/edit",
                name: "admin_merchant_config/edit",
                meta: {
                    title: "配置信息",
                },
                component: () => import("@v/admin-merchant/Config"),
            },
            {
                path: "/user_students",
                name: "user_students",
                meta: {
                    title: "用户列表",
                },
                component: () => import("@v/user/Student"),
            },

            {
                path: "/pay_merchants",
                name: "pay-merchantEdit",
                meta: {
                    title: "支付配置管理",
                },
                component: () => import("@v/admin-merchant/PayIndex"),
            },
            {
                path: "/pay_merchants/create",
                name: "pay-merchantEdit",
                meta: {
                    title: "添加支付配置",
                },
                component: () => import("@v/admin-merchant/PayForm"),
            },
            {
                path: "/pay_merchants/:id/edit",
                name: "pay-merchantEdit",
                meta: {
                    title: "编辑支付配置",
                },
                component: () => import("@v/admin-merchant/PayForm"),
            },
        ],
    },
];
